export default __webpack_public_path__ + "static/media/EG.e2f38452.svg";